import React from 'react';

import { CmRadio, CmRadioGroup, CmStack } from '@/components/uiParts';
import {
  maintenanceStatus,
  privateStatus,
  publicStatus,
  restrictedStatus,
  siteStatusMap,
} from '@/pages/camel-order/sites/service';
import { SiteStatus } from '@/services/Site/hooks/list/useSiteList';

type Props = {
  status: SiteStatus;
  onChange: (status: React.ReactText) => void;
};

export const SiteStatusRadioGroup: React.FC<Props> = ({ status, onChange }) => {
  return (
    <CmRadioGroup value={status.toString()} onChange={onChange}>
      <CmStack direction="row">
        <CmRadio size="md" value="1">
          {siteStatusMap[publicStatus].name}
        </CmRadio>
        <CmRadio size="md" value="0">
          {siteStatusMap[privateStatus].name}
        </CmRadio>
        <CmRadio size="md" value="2">
          {siteStatusMap[restrictedStatus].name}
        </CmRadio>
        <CmRadio size="md" value="3">
          {siteStatusMap[maintenanceStatus].name}
        </CmRadio>
      </CmStack>
    </CmRadioGroup>
  );
};
